import moment from 'moment';

class HomieReactConfig {
  
  static init = () => {
    HomieReactConfig.configureMoment();
  };
  
  static configureMoment = () => {
    moment.updateLocale('es', {
      monthsShort : [
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
      ]
    });
  }
}

export default HomieReactConfig;